import { useMemo } from 'react';

import { FieldStateKey, PermissionKey } from '@/common/constants';
import useGetPermissionToEditOverridableField from '@/modules/user/hooks/useGetPermissionToEditOverridableField';

const useOrphanConfigurationFieldsPermProps = () => {
  const isOrganizationOrphanPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.IS_ORGANIZATION_ORPHAN,
    FieldStateKey.IS_ORGANIZATION_ORPHAN,
  );
  const orphanStartTimingDaysPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.ORPHAN_START_TIMING_DAYS,
    FieldStateKey.ORPHAN_START_TIMING_DAYS,
  );
  const orphanOrganizationIdPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.ORPHAN_ORGANIZATION_ID,
    FieldStateKey.ORPHAN_ORGANIZATION_ID,
  );

  const hasFields = useMemo(() => [
    isOrganizationOrphanPermProps,
    // orphanStartTimingDaysPermProps,
    // orphanOrganizationIdPermProps,
  ].some((item) => !item.isAbsent), [
    isOrganizationOrphanPermProps,
    // orphanStartTimingDaysPermProps,
    // orphanOrganizationIdPermProps,
  ]);

  return {
    isOrganizationOrphanPermProps,
    orphanStartTimingDaysPermProps,
    orphanOrganizationIdPermProps,
    hasFields,
  };
};

export default useOrphanConfigurationFieldsPermProps;
